var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"slider-background"},[_c('canvas',{ref:"canvas"}),_c('div',{staticClass:"slider-background__white"})])}
var staticRenderFns = []

export { render, staticRenderFns }